/* Lollystore 3.0 — Step 7D PDP cleanup
   Presentation helper only.
   Finds the externally injected "Betala tryggt med:" block and adds classes
   so it can be compacted without guessing at app-specific selectors.
*/
(() => {
  const rootSelector = '.cc-main-product';
  const labelText = 'betala tryggt med';

  const normalize = (value) =>
    (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('sv-SE')
      .replace(/:$/, '');

  const findPaymentBlock = (label, root) => {
    let node = label;

    for (let depth = 0; depth < 5 && node && node !== root; depth += 1) {
      const visuals = node.querySelectorAll('img, svg, picture').length;
      const buttons = node.querySelectorAll('button, a').length;

      if (visuals >= 2 || (visuals >= 1 && buttons >= 2)) {
        return node;
      }
      node = node.parentElement;
    }

    // Common app pattern: heading/label followed by a dedicated icon wrapper.
    if (label.parentElement) {
      const sibling = label.nextElementSibling;
      if (sibling && sibling.querySelectorAll('img, svg, picture').length > 0) {
        return label.parentElement;
      }
    }

    return label.parentElement;
  };

  const enhancePaymentTrust = () => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const candidates = root.querySelectorAll('p, span, div, strong, small');
    let label = null;

    for (const el of candidates) {
      // Skip large containers so we only match the actual visible label.
      if (el.children.length > 3) continue;
      if (normalize(el.textContent) === labelText) {
        label = el;
        break;
      }
    }

    if (!label) return;

    const block = findPaymentBlock(label, root);
    if (!block || block.classList.contains('lolly-pdp-payment-trust')) return;

    label.classList.add('lolly-pdp-payment-trust__label');
    block.classList.add('lolly-pdp-payment-trust');
  };

  const init = () => {
    enhancePaymentTrust();

    // Some payment/app widgets render after DOMContentLoaded.
    const root = document.querySelector(rootSelector);
    if (!root || !('MutationObserver' in window)) return;

    const observer = new MutationObserver(() => enhancePaymentTrust());
    observer.observe(root, { childList: true, subtree: true });

    // Stop observing after app widgets normally have settled.
    window.setTimeout(() => observer.disconnect(), 8000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
